export function generatePath(
  gridSize: number,
  length: number,
  contiguous = true
): number[] {
  const total = gridSize * gridSize;
  if (length <= 0) return [];
  if (!contiguous) {
    // choose unique random indices
    const indices = Array.from({ length: total }, (_, i) => i);
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [indices[i], indices[j]] = [indices[j], indices[i]];
    }
    return indices.slice(0, Math.min(length, total));
  }

  // contiguous random walk
  const coordsFromId = (id: number) => ({
    r: Math.floor(id / gridSize),
    c: id % gridSize,
  });
  const idFromCoords = (r: number, c: number) => r * gridSize + c;

  const start = Math.floor(Math.random() * total);
  const path = [start];
  const directions = [
    { dr: -1, dc: 0 },
    { dr: 1, dc: 0 },
    { dr: 0, dc: -1 },
    { dr: 0, dc: 1 },
  ];

  while (path.length < Math.min(length, total)) {
    const last = path[path.length - 1];
    const { r, c } = coordsFromId(last);
    // build valid neighbors not already in path
    const neighbors: number[] = [];
    for (const d of directions) {
      const nr = r + d.dr;
      const nc = c + d.dc;
      if (nr >= 0 && nr < gridSize && nc >= 0 && nc < gridSize) {
        const nid = idFromCoords(nr, nc);
        if (!path.includes(nid)) neighbors.push(nid);
      }
    }

    if (neighbors.length === 0) {
      // dead end: pick a random tile that's not in path
      const rest = Array.from({ length: total }, (_, i) => i).filter(
        (i) => !path.includes(i)
      );
      if (rest.length === 0) break;
      const nxt = rest[Math.floor(Math.random() * rest.length)];
      path.push(nxt);
    } else {
      const nxt = neighbors[Math.floor(Math.random() * neighbors.length)];
      path.push(nxt);
    }
  }

  return path;
}
